<template>
    <div class="shop-container" >
        <!-- v-loading.fullscreen="loading" -->
        <div class="tab"><i>{{$t('arrowHall', {text: $t('introduce')})}}</i></div>
        <div class="det-item">
            <div class="det-item-left">
                <p>{{pageData.title}}</p>
                <ul>
                    <li>
                        <i>{{$t('arrowHall', {text: $t('introduce')})}}：</i>
                        <span class="html-content" v-html="pageData.content"></span>
                    </li>
<!--	
                    <li>
                        <i>{{$t('areaName')}}：</i>
                        <span>{{pageData.area_name}}</span>
                    </li>
                    <li>
                        <i>{{$t('arrowHall', {text: $t('address')})}}：</i>
                        <span>{{pageData.address}}</span>
                    </li>
                    <li>
                        <i>{{$t('mobile')}}：</i>
                        <span>{{pageData.phone}}</span>
                    </li> -->
                    <li v-if="pageData.club_type">
                        <i>{{$t('arrowHall', {text: $t('type')})}}：</i>
                        <span>{{pageData.club_type.name}}</span>
                    </li>
                    <li>
                        <i>{{$t('openingHours')}}：</i>
                        <span>{{pageData.business_hours}}</span>
                    </li>
                </ul>
            </div>
            <div class="det-item-right">
                <img :src="pageData.cover" alt="">
            </div>
        </div>
        <div class="tab"><i>{{$t('sceneDisplay')}}</i></div>
        <div class="det-pic">
            <div class="gallery-wrapper">
                <ul>
                    <base-swiper :speed="1" :direction="'left'" v-if="pageData.scene_graph && pageData.scene_graph.length > 0" :list="pageData.scene_graph"/>
                </ul>
            </div>
        </div>

        <div class="tab"><i>{{$t('businesIntroduction')}}</i></div>
        <div class="det-con">
            <p v-html="pageData.content"></p>
            <p><img :src="pageData.cover" alt=""></p>
        </div>

<!--        <div class="tab"><i>{{$t('address')}}</i></div>


        <div id="map" style="width:1240px;height:400px;"></div> -->
       
    </div>
</template>

<script>
import BaseSwiper from './s.vue'
export default {
    components:{
        BaseSwiper
    },
    data() {
        return {
            center: {
                lng: 0,
                lat: 0
            },
            zoom: 20,
            active: false,
            pageData: {},
            loading: false,
            longitude: "",
            latitude: ""
        }
    },
    created() {
        this.list()
    },
    mounted() {
        // this.init();
    },
    methods: {
        init(longitude, latitude) {
            let address = "";
            let that = this;
            var center = new qq.maps.LatLng(latitude, longitude);
            var map = new qq.maps.Map(document.getElementById('map'), {
                center: center,
                zoom: 13,
                disableDefaultUI: true
            });
            var marker = new qq.maps.Marker({
                position: center,
                map: map
            });
            var infoWin = new qq.maps.InfoWindow({
                map: map
            });
            var geocoder = new qq.maps.Geocoder({
                complete: function(res) {
                console.log(res);
                address = res.detail.nearPois[0].name;
                }
            });
            // qq.maps.event.addListener(map, "click", function(event) {
            //     this.longitude = event.latLng.getLat();
            //     this.latitude = event.latLng.getLng();
            //     console.log(event);
            //     let lat = new qq.maps.LatLng(this.longitude, this.latitude);
            //     geocoder.getAddress(lat);
            //     setTimeout(() => {
            //     infoWin.open();
            //     infoWin.setContent(
            //         '<div style="text-align:center;white-space:nowrap;">' +
            //         address +
            //         "</div>"
            //     );
            //     infoWin.setPosition(event.latLng);
            //     }, 200);
            // });
        },
        list() {
            this.loading = true
            let id = this.$route.query.id
            this.$api.clubdetail({
                id
            }).then(res =>{
                setTimeout(() => {
                    this.loading = false
                })
                if(res.status) {
                    this.pageData = res.data
                    this.init( this.pageData.longitude, this.pageData.latitude)
                } 
            })
        },
        handler() {
            this.center.lng = this.pageData.longitude
            this.center.lat = this.pageData.latitude
        },
        draw ({el, BMap, map}) {
            const pixel = map.pointToOverlayPixel(new BMap.Point(this.pageData.longitude, this.pageData.latitude))
            el.style.left = pixel.x - 50 + 'px'
            el.style.top = pixel.y - 50 + 'px'
        }
     }
}
</script>

<style lang="scss" scoped>

.sample {
  width: 90px;
  height: 18px;
  line-height: 8px;
  background: url('http://www.sanlida.cn/templates/pccommon/images/ico_mark_3.png') no-repeat;
  background-size:  100% 100%;
  overflow: hidden;
  color: #fff;
  text-align: center;
  padding: 10px;
  position: absolute;
  font-size: 12px;
}
.sample.active {
  color: #fff;
}


.shop-container {
    overflow: hidden;
}
.tab{
    width: 100%;
    float: left;
    margin-top: 20px;
    border-bottom: 2px solid #e7442f;
    i{
        color: #fff;
        font-size: 18px;
        padding:10px 20px;
        background: #e7442f;
        float: left;
    }
}
.det-item {
    width: 1226px;
    float: left;
    padding: 10px 20px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    &-left {
        width: 750px;
        float: left;
        font-size: 14px;
        p {
            color: #333;
            font-size: 18px;
            margin: 10px 0;
            font-weight: 600;
        }
        ul {
            li {
                width: 100%;
                float: left;
                margin-bottom: 8px;
                i{
                    min-width: 80px;
                    float: left;
                    color: #333;
                    font-weight: 600;
                    line-height: 22px;
                }
                span {
                    max-width: 600px;
                    float: left;
                    line-height: 22px;
                }
            }
        }
    }
    &-right {
        float: right;
        width: 200px;
        margin: 25px 20px 0 0;
        box-shadow: 0 0 15px rgba(0, 0, 0, .1);
        img {
            width: 200px;
            height: 200px;
        }
    }
}
.det-pic {
    width: 1226px;
    float: left;
    padding: 10px 20px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    .gallery-wrapper {
        height: 195px;
        width: 100%;
        overflow: hidden;
        position: relative;
        ul {
            height:195px;
            width:100000px;
            position:absolute;
            left:0;
            z-index: 100;
            li {
                display:block;
                float:left;
                margin:5px;
                height:185px;
                position:relative;
                img {
                    width: 260px;
                    height: 185px;
                }
            }
        }
    }
}

span{
    p {
        img{
            width: 100% !important;
        }
    }
    
}
.bm-view {
  width: 100%;
  height: 400px;
  float: left;
}

.det-con {
    width: 1226px;
    float: left;
    font-size: 14px;
    line-height: 24px;
    padding:10px 20px;
    border:1px solid #e5e5e5;
    box-sizing: border-box;
    
}
</style>

<style scoped>

.det-con p >>> img {
    width: 100%;
}
.html-content >>> img {
    width: 100%;
}
</style>